module.exports = __webpack_public_path__ + "img/valuationResultDVBox.080fa5af.png";